/* eslint-disable jsx-a11y/anchor-is-valid */
import { Input } from "../../../components/core/Input";
import Select from "../../../components/others/Select/Select";
import { useForm } from "react-hook-form";
import StyledWrapper from "./style";
import { PrimaryButton } from "../../../components/others/ButtonPrimary";
import LavorisService from "../../../services/LavorisService";
import { InputEmail } from "../../../components/others/InputEmail";
import { useSelector } from "react-redux";
import { RootState } from "../../../store/combineReducer";
import { useSearchParams } from "react-router-dom";
import { useEffect, useState } from "react";
import { individualEntities } from "../../../services/publicData/PublicData.type";
import { PhoneNumber } from "../../../components/others/PhoneNumber";
import { useAlert } from "../../../hooks/useAlert";
import { getErrorMessage } from "../../../utils";
import InputRadio from "../../../components/others/InputRadio/InputRadio";

type TProps = {
  onClose: Function
}

export default function AddContacts({ onClose }: TProps) {
  const [contactsPositionsValues, setContactsPositionsValues] = useState<individualEntities>([{ name: "", value: "" }]);
  const [searchParams, setSearchParams] = useSearchParams("");
  const [isLoading, setIsLoading] = useState(false)
  const {
    register,
    handleSubmit,
    reset,
    control,
    formState: { errors },
  } = useForm({
    mode: "all",
  });

  const LavorisInstance = LavorisService.getInstance();
  const { showAlert } = useAlert();
  const { currentCompany, companies } = useSelector((state: RootState) => state.user,);



  const onSubmit = async (data: any) => {
    const company = currentCompany ? currentCompany.id : companies[0].id
    setIsLoading(true)
    const updatedData = {
      ...data,
      company_id: company,
      name: `${data.lastname.trim()}, ${data.name.trim()}`,
      billingEmailEnabled: data.billingEmailEnabled === 'Si' ? true : false,
    }
    try {
      await LavorisInstance.CompanyServices.addContacts(updatedData,);
      onClose?.()
    } catch (err: any) {
      console.log(err);
      showAlert(getErrorMessage({ title: 'Error al crear el contacto', err }));
    }
    finally {
      setIsLoading(false)
    }
  };

  const getContactsPositions = async () => {
    try {
      const publicData = await LavorisInstance.PublicData.getPublicData();
      if (publicData) {
        setContactsPositionsValues(publicData.contactsPositions)
      }
    } catch (e: any) {
      console.log(e);
    }

  };

  useEffect(() => {
    reset();
    getContactsPositions();
  }, []);

  return (
    <form onSubmit={handleSubmit(onSubmit)}>
      <StyledWrapper.FormContainer>
        <Input
          register={register}
          fieldName="lastname"
          label="Apellido"
          type="text"
          error={errors?.lastname}
          required
        />
        <Input
          register={register}
          fieldName="name"
          label="Nombre"
          type="text"
          error={errors?.name}
          required
        />
        <Select
          fieldName="position"
          label="Puesto en la empresa"
          options={contactsPositionsValues}
          register={register}
          required
          error={errors?.position}
          styles="rounded w-full h-[50px]"
        />
        <InputEmail
          label="E-mail"
          nameInput="email"
          register={register}
          required
          error={errors}
        />

        <PhoneNumber
          label="Teléfono"
          fieldName="phoneNumber"
          control={control}
          required
          error={errors?.phoneNumber}
        />
        <InputRadio
          label="¿Habilitado para recibir emails de facturación?"
          fieldName="billingEmailEnabled"
          option1="Si"
          option2="No"
          register={register}
          defaultValue="No"
          error={errors?.billingEmailEnabled}
          globalContainerStyles="mt-5"
        />
      </StyledWrapper.FormContainer>
      <div className="w-full">
        <PrimaryButton
          type="submit"
          text="Crear contacto"
          styles="bg-red-500 font-bold text-white mt-12"
          disabled={isLoading}
        />
      </div>
    </form>
  );
}
